import { Button } from "@/components/ui/button";
import { Printer } from "lucide-react";

export function BadgesTab({ participants, filtered, badgeFormat, setBadgeFormat, generateBadges }) {
  return (
    <div className="space-y-6" data-testid="badges-tab">
      <div className="bg-[#0B0F19] border border-[#1E293B] rounded-xl p-6">
        <h3 className="text-white font-semibold mb-2 flex items-center gap-2"><Printer className="h-4 w-4 text-[#0099CC]" /> Generation de badges</h3>
        <p className="text-[#64748b] text-sm mb-6">Generez des badges nominatifs avec QR code pour chaque participant. Choisissez le format selon vos besoins d'impression.</p>

        <div className="grid sm:grid-cols-2 gap-4 mb-6">
          <button
            data-testid="badge-format-card"
            onClick={() => setBadgeFormat("card")}
            className={`p-4 rounded-xl border-2 text-left transition-all ${badgeFormat === "card" ? "border-[#0099CC] bg-[#0099CC]/10" : "border-[#2A3441] hover:border-[#0099CC]/40"}`}
          >
            <div className="text-white font-medium mb-1">Format Carte (A6)</div>
            <div className="text-xs text-[#64748b]">1 badge par page — ideal pour impression professionnelle et plastification</div>
          </button>
          <button
            data-testid="badge-format-grid"
            onClick={() => setBadgeFormat("grid")}
            className={`p-4 rounded-xl border-2 text-left transition-all ${badgeFormat === "grid" ? "border-[#0099CC] bg-[#0099CC]/10" : "border-[#2A3441] hover:border-[#0099CC]/40"}`}
          >
            <div className="text-white font-medium mb-1">Format Grille (A4)</div>
            <div className="text-xs text-[#64748b]">6 badges par page — economique, a decouper apres impression</div>
          </button>
        </div>

        <div className="flex gap-3 flex-wrap">
          <Button
            data-testid="generate-all-badges-btn"
            onClick={() => generateBadges(participants, badgeFormat)}
            disabled={participants.length === 0}
            className="bg-[#0099CC] hover:bg-[#0088B5] text-white"
          >
            <Printer className="h-4 w-4 mr-2" /> Generer tous les badges ({participants.length})
          </Button>
          {filtered.length > 0 && filtered.length !== participants.length && (
            <Button
              data-testid="generate-filtered-badges-btn"
              onClick={() => generateBadges(filtered, badgeFormat)}
              variant="outline"
              className="border-[#2A3441] text-[#94A3B8] hover:text-white"
            >
              <Printer className="h-4 w-4 mr-2" /> Badges filtres ({filtered.length})
            </Button>
          )}
        </div>
      </div>

      {/* Preview */}
      {participants.length > 0 && (
        <div className="bg-[#0B0F19] border border-[#1E293B] rounded-xl p-6">
          <h3 className="text-white font-semibold mb-4">Apercu — {participants.length} participant(s)</h3>
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-3">
            {participants.slice(0, 12).map(p => (
              <div key={p.id} className="bg-[#151B2B] border border-[#2A3441] rounded-xl p-4 flex items-center gap-3">
                <div className={`h-10 w-10 rounded-full flex items-center justify-center text-sm font-bold shrink-0 ${p.is_vip || p.category === "vip" ? "bg-[#F59E0B]/20 text-[#F59E0B]" : "bg-[#0099CC]/20 text-[#0099CC]"}`}>
                  {(p.first_name?.[0] || "")}{(p.last_name?.[0] || "")}
                </div>
                <div className="min-w-0">
                  <div className="text-white text-sm font-medium truncate">{p.first_name} {p.last_name}</div>
                  <div className="text-xs text-[#64748b] truncate">{p.category === "vip" ? "VIP" : p.category || "Standard"} — {p.reference}</div>
                </div>
                <button
                  data-testid={`badge-single-${p.id}`}
                  onClick={() => generateBadges([p], badgeFormat)}
                  className="ml-auto text-[#0099CC] hover:text-white p-1.5 rounded-lg hover:bg-[#0099CC]/10 transition-colors shrink-0"
                  title="Generer le badge"
                >
                  <Printer className="h-4 w-4" />
                </button>
              </div>
            ))}
          </div>
          {participants.length > 12 && <p className="text-[#64748b] text-xs mt-3 text-center">+ {participants.length - 12} autres participants</p>}
        </div>
      )}
    </div>
  );
}
